/**
 * Reference vocabularies for contacts -- client mirror of
 * server/src/components/contact_types.js. Keep the two in sync.
 *
 * Carries an icon per type as well as a label, so list items read their icon
 * from the vocabulary instead of hard-coding a switch in every template.
 * Every icon here is already used elsewhere in the client, so the set is
 * known-good against the loaded FontAwesome build.
 */

export const TYPES = [
    {value: 'restaurant', label: 'Restaurant', icon: 'fa-utensils'},
    {value: 'hotel', label: 'Hotel', icon: 'fa-hotel'},
    {value: 'booking-office', label: 'Booking Office', icon: 'fa-clipboard-check'},
    {value: 'vendor', label: 'Vendor', icon: 'fa-truck'},
    {value: 'guide', label: 'Guide', icon: 'fa-compass'},
    {value: 'driver', label: 'Driver', icon: 'fa-taxi'},
    {value: 'tennis', label: 'Tennis / Tournament', icon: 'fa-tennis-ball'},
    {value: 'emergency', label: 'Emergency', icon: 'fa-exclamation-triangle'},
    {value: 'other', label: 'Other', icon: 'fa-address-card'}
];

// The link's role reuses the type vocabulary -- see the server module for why.
export const ROLES = TYPES;

export function typeLabel(value) {
    const type = TYPES.find(t => t.value === value);
    return type ? type.label : value;
}

export function typeIcon(value) {
    const type = TYPES.find(t => t.value === value);
    return type ? type.icon : 'fa-address-card';
}

// A link shows its own role when it has one, else the contact's type.
export function roleLabel(role, type) {
    return typeLabel(role || type);
}

/**
 * A company has no id -- it is the string on its contacts -- but card paths
 * split props on "," and ";" and vue-router decodes the path once, so the
 * raw name can't ride in a card prop. URL-safe base64 survives both.
 */
export function companyKey(company) {
    return btoa(unescape(encodeURIComponent(company || '')))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function companyFromKey(key) {
    if (!key) return '';
    const b64 = String(key).replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(escape(atob(b64 + '='.repeat((4 - b64.length % 4) % 4))));
}
